import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAppveyorComponent } from './simple-icons-appveyor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAppveyorComponent ],
    exports:      [ SimpleIconsAppveyorComponent ],
    bootstrap:    []
})
export class SimpleIconsAppveyorModule {}
